<template>
  <div class="medical-guide" :class="{
    'sn-f-b-s': guideInfo.length > 0,
    'sn-f-c-c': guideInfo.length === 0
  }">
    <template v-if="guideInfo.length > 0">
      <div class="sn-f-s-0 sn-navigator">
        <div class="sn-f-col-c-c top">
          <div class="top-title">{{ $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_JYZN) }}</div>
        </div>
        <div class="func">
          <div class="sn-f-c-c sn-omit sn-pointer func-line"
          :class="{'interaction': item.dictCode === selected.dictCode}"
          :key="item.dictCode" v-for="item in guideInfo" @click="selected = item; secretary = {};">{{ item.dictValue }}</div>
        </div>
      </div>
      <div class="sn-f-1 sn-f-col-b-s guide-region">
        <sn-breadcrumb :breadcrumb="[{
          title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_JYZN),
        }]"></sn-breadcrumb>
        <div class="sn-f-1 guide-blank" :class="{'sn-f-col-b-c': secretary.guideId}">
          <div class="sn-table" v-if="!secretary.guideId">
            <table>
              <thead>
                <tr>
                  <th style="width: 40px;">序号</th>
                  <th>标题</th>
                  <th style="width: 80px;">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="guide.guideId" v-for="(guide, i) in selected.guides">
                  <td>{{ i + 1 }}</td>
                  <td>{{ guide.guideTitle }}</td>
                  <td class="sn-pointer sn-fc-main" @click="suffix(guide);">查看</td>
                </tr>
              </tbody>
            </table>
          </div>
          <template v-else>
            <div class="sn-f-s-0 guide-title">{{ secretary.guideTitle }}</div>
            <div class="sn-f-1 guide-secretary" v-html="secretary.guideContent"></div>
          </template>
        </div>
      </div>
    </template>
    <sn-no-data v-else></sn-no-data>
  </div>
</template>
<script type="text/javascript">
import { gatherConfig } from '@/common/utils/function-config';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  mixins: [HomepageMixin],
  data() {
    return {
      guideInfo: [],
      selected: {},
      secretary: {}
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.secretary.guideId) {
      this.secretary = {};
      next(false);
    }
    else next();
  },
  created: function() {
    document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_JYZN) || this.$sn.utils.getHospitalTitle();
    this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_JYZN) || this.$sn.utils.getHospitalTitle();
    this.getGuideInfo();
  },
  methods: {
    getGuideInfo() {
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: this.$sn.format.caption(Swagger.getMedicalGuideTable, [this.$sn.utils.getHospitalId()]),
        query: {
          multiCode: this.$route.query.id || ''
        }
      }).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data && result.data.length > 0) {
              result.data = result.data.filter(res => res.guides && res.guides.length > 0);
              result.data.forEach((el, i) => {
                result.data[i].guides = this.$sn.format.digitalSort(result.data[i].guides, '1', 'guideOrder');
              });
              this.guideInfo = result.data;
              this.selected = this.guideInfo[0];
            }
            else {
              this.$sn.assembly.modal({
                caption: this.$sn.utils.getSessionStorage('HospitalMessages').C.C002,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: this.$sn.utils.getSessionStorage('HospitalMessages').C.C001,
            isCancel: false
          });
        }
      });
    },
    suffix(guide) {
      // 富文本展示
      if (guide.showType === '0') {
        this.secretary = guide;
      }
      // 站内功能
      else if (guide.showType === '1') {
        let func;
        if (guide.showExt && this.$sn.validate.json(guide.showExt)) {
          const extend = JSON.parse(guide.showExt);
          func = gatherConfig().find(result => result.id === extend.joinId);
        }
        if (func && func.id && this.$sn.utils.isOpenFunction(func.id)) {
          this.homepage_mixin_navigateUrl(func.url, func, func.params);
        }
      }
      // 外部 H5
      else if (guide.showType === '2') {
        let url = '';
        if (guide.showExt && this.$sn.validate.json(guide.showExt)) {
          const extend = JSON.parse(guide.showExt);
          url = extend.url;
        }
        if (url) {
          this.homepage_mixin_navigateUrl(url);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.medical-guide {
  overflow: hidden;
  width: 100%;
  height: 100%;

  .guide-region {
    overflow: hidden;
    height: 100%;

    .guide-blank {
      overflow: hidden;
      width: 100%;
      padding: 20px;

      .guide-title {
        @include fs(28);

        overflow: hidden;
        width: 100%;
        font-weight: bold;
        color: $text1;
        text-align: center;
        border-bottom: 1px solid $border1;
        padding-bottom: 20px;
        margin-bottom: 20px;
      }

      .guide-secretary {
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;
      }
    }
  }
}
</style>
